module.exports = __webpack_public_path__ + "fonts/837069e.otf";